export const Topics = {
  pdc: [
    {
      title: $localize `:@@parashift_shared.webhooks.document_inbound:Document inbound`,
      topics: [
        'document-received',
        'preprocessing-done'
      ]
    },
    {
      title: $localize `:@@parashift_shared.webhooks.batch:Batch`,
      topics: [
        'batch-created',
        'automatic-separation-done',
        'ready-for-separation-first-level',
        'ready-for-separation-second-level',
        'ready-for-separation-third-level',
        'ready-for-separation-qc',
        'separation-done',
        'batch-done',
        'batch-failed'
      ]
    },
    {
      title: $localize `:@@parashift_shared.webhooks.classification:Classification`,
      topics: [
        'automatic-classification-done',
        'ready-for-classification-first-level',
        'ready-for-classification-second-level',
        'ready-for-classification-third-level',
        'ready-for-classification-qc',
        'classification-done'
      ]
    },
    {
      title: $localize `:@@parashift_shared.webhooks.extraction:Extraction`,
      topics: [
        'automatic-extraction-done',
        'ready-for-extraction-first-level',
        'ready-for-extraction-second-level',
        'ready-for-extraction-third-level',
        'ready-for-extraction-qc',
        'extraction-done'
      ]
    },
    {
      title: $localize `:@@parashift_shared.webhooks.delivery:Delivery`,
      topics: [
        'processing-finished',
        'processing-failed'
      ]
    }
  ],

  getSlugs() {
    const topics = [];
    this['pdc'].forEach(topic => topic.topics.forEach(slug => topics.push(slug)));
    return topics.join(',');
  },

  getTopics() {
    return this.pdc;
  }
};
